(function () {
  'use strict';

  angular.module('sempraWebapp').service('getUtcTimeService', getUtcTimeService);

  /** @ngInject */
  function getUtcTimeService () {
    this.getTime = function (date) {
      date.setHours(0, 0, 0, 0); //Midnight
      var timezoneOffeset = date.getTimezoneOffset();
      return date.getTime() - timezoneOffeset * 60000;
    };
  }
})();
